<template>
  <div class="test-buy-report">
    <div class="page-header">
      <h2>
        测买报告
        <span style="float:right; font-size:14px;">数据最后更新时间： {{ $moment(pageinfo.updateTime).format('YYYY-MM-DD')}}</span>
      </h2>
    </div>
    
    <!-- <el-button class="downloadpdfbtn" type="danger" size="small" @click="downloaddata" :loading="downloading">下载报告</el-button> -->
    
    <div class="test-buy-report-info">
      <table>
        <tr>
          <td colspan="4" class="test-buy-table-td-header">测买目标基础信息</td>
        </tr>
        <tr>
          <td>商品名称</td>
          <td colspan="3">{{ pageinfo.productName }}</td>
        </tr>
        <tr>
          <td>商品链接</td>
          <td colspan="3">{{ pageinfo.url }}</td>
        </tr>
        <tr>
          <td>店铺名称</td>
          <td>{{ pageinfo.shopName }}</td>
          <td>卖家ID</td>
          <td>{{ pageinfo.sellerName }}</td>
        </tr>
        <tr>
          <td>订单编号</td>
          <td>1753918466124297156</td>
          <td width="100">测买时间</td>
          <td>{{ $moment(pageinfo.orderTime).format('YYYY-MM-DD') }}</td>
        </tr>
        <tr>
          <td width="100">付款方式</td>
          <td>{{ pageinfo.payment }}</td>
          <td width="100">快递</td>
          <td>{{ pageinfo.expressName }}</td>
        </tr>
        <tr>
          <td width="100">付款金额</td>
          <td>{{ pageinfo.orderPrice }}</td>
          <td width="100">快递单号</td>
          <td>{{ pageinfo.expressNumber }}</td>
        </tr>
        <tr>
          <td width="100">税费</td>
          <td>{{ pageinfo.tax }}</td>
          <td width="100">库存</td>
          <td>{{ pageinfo.stock }}</td>
        </tr>
        <tr>
          <td width="100">运费</td>
          <td>{{ pageinfo.postage }}</td>
          <td width="100">发货地</td>
          <td>{{ pageinfo.receiptAddress }}</td>
        </tr>
        <tr>
          <td colspan="4" class="test-buy-table-td-header">测买订单／退货／返还信息</td>
        </tr>
        <tr>
          <td>类型</td>
          <td>{{ pageinfo.returnFee != null ? '返还' : pageinfo.salesReturnFee != null ? '退货' : '' }}</td>
          <td>时间</td>
          <td></td>
        </tr>
        <tr>
          <td>快递费</td>
          <td>{{ pageinfo.salesReturnFee != null ? pageinfo.salesReturnFee : pageinfo.returnFee != null ? pageinfo.returnFee : '' }}</td>
          <td>运单号</td>
          <td></td>
        </tr>
        <tr>
          <td>快递地址</td>
          <td colspan="3">{{ pageinfo.returnUrl != null ? pageinfo.returnUrl : '' }}</td>
        </tr>
        <tr>
          <td colspan="4" class="test-buy-table-td-header">测买商品信息</td>
        </tr>
        <tr>
          <td>外包装</td>
          <td>
            <el-image :src="pageinfo.packagePhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </td>
          <td>快递单</td>
          <td>
            <el-image :src="pageinfo.waybillPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </td>
        </tr>
        <tr>
          <td>订单图</td>
          <td colspan="3">
            <el-image :src="pageinfo.orderPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </td>
        </tr>
        <tr>
          <td>商品图</td>
          <td colspan="3">
            <el-image :src="pageinfo.frontPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <el-image :src="pageinfo.backPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <el-image :src="pageinfo.leftPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <el-image :src="pageinfo.rightPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </td>
        </tr>
        <tr>
          <td>标签</td>
          <td colspan="3">
            <el-image :src="pageinfo.labelPhoto">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </td>
        </tr>
        <tr>
          <td>SN</td>
          <td colspan="3">
            <el-image :src="pageinfo.SN">
              <div slot="error"></div>
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td colspan="3">
            {{ pageinfo.note }}
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      testid: this.$route.params.Testid,
      taskid: this.getCurrentInfo().taskid,
      pageinfo: {},
      downloading: false,
    }
  },

  mounted(){
    this.testbuyDetail()
  },

  methods: {
    
    /**
     * 获取测买流程详情
     */
     testbuyDetail: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/testbuyDetail?taskId=' + that.taskid + '&testId=' + that.testid
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('testbuyDetail', rex)
          let res = rex.results[0]
          that.pageinfo = res
        },
        error: function(response) {
          console.log('testbuyDetail', response)
        }
      })
    },

    /**
     * 下载PDF
     */
    downloaddata: function(){
      let that = this
      that.downloading = true
      let url = that.API_URL + '/v3/price/testbuy/htmltoPdf?taskId='
                +that.taskid
                +'&assetId='
                +that.assetid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log('downloaddata', data)
          that.getPdfUrl()
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 获取下载地址
     */
    getPdfUrl: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/downloadPdf?taskId='
                +that.taskid
                +'&assetId='
                +that.assetid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log('getPdfUrl', data)
          that.downFile(data.results.url)
          that.downloading = false
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 下载
     */
    downFile (url) {
      const link = document.createElement('a')
      console.log(link)
      link.href = url
      link.target = '_blank'
      link.click()
    },

  }
}
</script>